export default "__VITE_ASSET__e4fec1c7__"